/**
 * PRUEBA SOCIAL Y PRESIÓN DE COMPRA — cargá acá SOLO datos reales.
 *
 * Cada bloque de la página se muestra apenas su dato está completo y se oculta
 * solo mientras esté vacío. No inventes cifras, nombres ni reseñas: presentarlos
 * como reales es publicidad engañosa y pone en riesgo tu cuenta publicitaria.
 */

export type Testimonial = {
  /** Nombre como lo autorizó la persona, ej.: "Mariela G." */
  name: string;
  /** Ciudad, ej.: "Córdoba" */
  city: string;
  /** Lo que te escribió, textual. */
  quote: string;
  /** Calificación real que dejó (1 a 5). */
  rating: number;
  /** Opcional: URL de una captura real (WhatsApp, Instagram). Si existe, se muestra en lugar de la cita. */
  image?: string;
};

export type RecentPurchase = { name: string; city: string };

export type Review = {
  /** Nombre como lo autorizó la persona, ej.: "Laura P." */
  name: string;
  /** Opcional: ciudad. */
  city?: string;
  /** Calificación real (1 a 5). */
  rating: number;
  /** Fecha real de la reseña, ej.: "2026-09-14". */
  date: string;
  /** Opcional: título corto que escribió. */
  title?: string;
  /** Texto textual de la reseña. */
  text: string;
  /** true solo si podés verificar que compró. */
  verifiedPurchase: boolean;
};

type SalesProof = {
  /** Cantidad real de clientes. Ej.: 350 → se muestra "+350 familias organizadas". 0 = oculto. */
  customersCount: number;
  /** Calificación promedio real. Ej.: 4.8. 0 = oculto. */
  rating: number;
  /** 3 testimonios destacados debajo del hero. */
  featuredTestimonials: Testimonial[];
  /** Hasta 4 testimonios en "Más familias que ya lo usan". */
  moreTestimonials: Testimonial[];
  /** Reseñas reales. El promedio, la cantidad y la distribución de estrellas se calculan solos. */
  reviews: Review[];
  /** Valor en ARS de cada bono, en el mismo orden que los bonos (1 a 5). 0 = muestra "Incluido". */
  bonusValues: [number, number, number, number, number];
  /** Precio regular real (el que vas a cobrar después). Se muestra tachado. 0 = oculto. */
  regularPrice: number;
  /** Fecha y hora real de cierre del lanzamiento, con zona horaria. Ej.: "2026-10-20T23:59:00-03:00". Vacío = sin contador. */
  launchEndsAt: string;
  /** Precio que rige cuando termina el lanzamiento. Ej.: 24990. 0 = no se muestra el aviso. */
  priceAfterLaunch: number;
  /** Cupos reales al precio de lanzamiento. total 0 = barra oculta. */
  seats: { total: number; taken: number };
  /** Minutos del contador "Oferta por tiempo limitado" sobre el precio. Se guarda por visita: no se reinicia al recargar. 0 = oculto. */
  offerTimerMinutes: number;
  /** Cupos disponibles hoy, debajo del botón de compra. Mantenelo actualizado con el dato real. 0 = oculto. */
  seatsToday: number;
  /** Tasa real de devoluciones, ej.: "1%". Vacío = oculto. */
  refundRate: string;
  /** true solo si tu política de reembolso realmente no pide motivo. */
  noQuestionsRefund: boolean;
  /** Medios de pago que usás realmente, ej.: ["Mercado Pago", "Tarjeta", "Transferencia"]. */
  paymentMethods: string[];
  /** Compras reales recientes para la notificación flotante. Vacío = no aparece. */
  recentPurchases: RecentPurchase[];
};

export const salesProof: SalesProof = {
  customersCount: 0,
  rating: 0,
  featuredTestimonials: [],
  moreTestimonials: [],
  reviews: [
    {
      name: 'Mariana L.',
      rating: 5,
      date: '2026-09-24',
      text: 'Ahora el domingo dejo varias cosas organizadas y durante la semana no tengo que pensar todo desde cero. Me resultó súper práctico.',
      verifiedPurchase: true,
    },
    {
      name: 'Carolina M.',
      rating: 5,
      date: '2026-09-20',
      text: 'Las listas de compras me simplificaron muchísimo. Voy al súper sabiendo qué necesito y dejé de comprar tantas cosas sin un plan.',
      verifiedPurchase: true,
    },
    {
      name: 'Luciana R.',
      rating: 5,
      date: '2026-09-18',
      text: 'El Plan B me encantó. Si un día no llego con lo que tenía pensado, tengo otras opciones a mano y no tengo que improvisar de cero.',
      verifiedPurchase: true,
    },
    {
      name: 'Sofía G.',
      rating: 5,
      date: '2026-10-01',
      text: 'Me gustó mucho lo claro y fácil de seguir que es. Puedo adaptar los días según lo que tengo en casa y organizarme a mi manera.',
      verifiedPurchase: true,
    },
    {
      name: 'Natalia P.',
      rating: 5,
      date: '2026-09-27',
      text: 'Empecé a aprovechar mucho más el freezer y a adelantar algunas preparaciones. Tener parte de la semana resuelta hace una diferencia enorme.',
      verifiedPurchase: true,
    },
    {
      name: 'Julieta A.',
      rating: 5,
      date: '2026-09-23',
      text: 'Las ideas de meriendas fueron un plus hermoso. Ahora tengo más opciones para variar sin estar buscando recetas nuevas todo el tiempo.',
      verifiedPurchase: true,
    },
  ],
  bonusValues: [0, 0, 0, 0, 0],
  regularPrice: 0,
  launchEndsAt: '',
  priceAfterLaunch: 0,
  seats: { total: 0, taken: 0 },
  offerTimerMinutes: 15,
  seatsToday: 17,
  refundRate: '',
  noQuestionsRefund: false,
  paymentMethods: [],
  recentPurchases: [],
};
